import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setActivity } from '../../store/AppSlice';

const BeinnSgritheall = () => {

    const dispatch = useDispatch();

    const navigateToActivity = () => {
      dispatch(setActivity("BEINN_SGRITHEALL"));
    }

    return (
      <div>
        <h2 className="walks-link-heading"><a  onClick={navigateToActivity}>Beinn Sgritheall</a></h2>
        <p className="walk-text">The mountain behind the cottage overlooking Arnisdale.  A stunning mountain walk with views across to Knoydart and along Loch Hourn out to the small Isles and Skye. 
        </p>
                                            
      </div>
    );
}

export default BeinnSgritheall
